import { getAuthentication } from "../../lib/auth";
import { BETTING_WEBSITE_RELATIVES_URL } from "../../lib/env";
import { gqlRequest } from "../../lib/functions";
import { BETTINGWEBSITELANGUAGEGQLSCHEMA } from "../../lib/gql/BettingWebsite.Language";
import { IBettingWebsiteLanguage } from "../../types/BettingWebsite.Language";

export async function getLanguages(): Promise<IBettingWebsiteLanguage[]> {
  const gqlString = `query{
        GetBettingWebsiteLanguages{
            ${BETTINGWEBSITELANGUAGEGQLSCHEMA}
        }
    }`;
  try {
    const response = await gqlRequest<{
      GetBettingWebsiteLanguages: IBettingWebsiteLanguage[];
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.GetBettingWebsiteLanguages || [];
  } catch (err) {
    throw err;
  }
}
